/* eslint-disable @typescript-eslint/indent */
import Discount from '@/components/common/Icons/Discount';
import SocialShareModal from '@/components/common/SocialShareModal';
import VideoModal from '@/components/common/VideoModal';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { companyImage } from '@/utils/common/env.constants';
import {
  createImageUrl,
  getCountryFromCache,
  getPriceDetails,
  getRegistrationStatus,
} from '@/utils/helper/helperFunction';
import { Container, Tooltip, Typography } from '@pwskills/rachnaui';
import { ArrowRedo, Home, InformationCircle } from '@pwskills/rachnaui/Icons';
import PlayIcon from '@pwskills/rachnaui/Icons/Play';
import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState } from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import Link from 'next/link';
import {
  COURSE_PURCHASE_TYPE,
  PAGE_FROM_ROUTES,
  REGISTRATION_STATUS,
} from '@/utils/common/common.constants';
import CardFooterButton2 from '@/components/common/CoursesCard/CardFooterButton2';
import { DOMAIN } from '@/utils/homePage/env.constants.utils';
import useRedirectToCategory from '@/hooks/useRedirectionToCategory';
import { getNavigationContext } from '@/utils/navigationContext';
import useUserDetails from '@/store/userDetails';
import {
  LeadCaptureEnquiryType,
  LeadCaptureType,
  LeadType,
  ModalType,
} from '@/interfaces/leadCapture.enum';
import { usePWAuthWebSDK } from '@/hooks/usePWAuthWebSDK';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import { extractParagraphText } from '@/utils/helper/courseDescription';
import { sendSkCtaClickedEvent } from '@/utils/GAEventFunction';
import { AuthEnums } from '@/GlobalEnums/enums';
import { dataLayer } from '../../../utils/common/dataLayer.utils';
// import HeroMetaData from '../../CourseDescriptionPageAmature/HeroSection/HeroMetaData';
import OnboardingLeadForm from '../OnboardingLeadForm';
import { GAevent } from '../../../utils/firebase.utils';

/* HeroContainer page */
const HeroContainer = ({ isArmature = true }: { isArmature: boolean }) => {
  const { courseDetails, isCourseBought } = useContext(CourseDescriptionContext);
  const [modelOpen, setModelOpen] = useState<boolean>(false);
  const [emiModal, setEmiModal] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const {
    title,
    name,
    // offerDescription,
    videoURL,
    isJobAssistanceProgram,
    img,
    description,
    pricing,
    coursePurchaseType,
    // categoryDetails,
    ratingAverage,
    _id,
    slug,
    hashtagDetails,
    emi,
    // registration,
    registrationStartDate,
    registrationEndDate,
    courseType,
    thumbnailImgAltText,
    // keyValueMetaInfo,
    parentCategoryDetails,
    courseMetaDetails,
  } = courseDetails || {};

  const registration = {
    startDate: registrationStartDate || '',
    endDate: registrationEndDate || '',
  };
  const courseTitle = name || title;
  const effectivePricing = courseDetails?.courseMetaDetails?.pricing || pricing;
  const priceDetails = getPriceDetails(effectivePricing);
  const effectiveImg = courseDetails?.courseMetaDetails?.about?.thumbnailUrl || img;
  const effectiveDescription =
    extractParagraphText(courseDetails?.shortDescription as string) || description;
  const router = useRouter();
  const categoryName =
    courseDetails?.categoryDetails?.name ||
    courseDetails?.categoryDetails?.title ||
    parentCategoryDetails?.title;
  const categorySlugValue =
    courseDetails?.categoryDetails?.slug ||
    parentCategoryDetails?.slug ||
    (router.query.categorySlug as string | undefined);
  const { goToPlanSection, masterclassSlug } = router.query;
  const navigationContext = getNavigationContext(router.asPath);
  const { actualPrice, currency, discount, currentPrice } = priceDetails || {};
  const [isHovered, setIsHovered] = useState(false);
  const { curriculumPdf } = courseDetails?.courseMetaDetails || {};
  const utmQuery = useUTMParameters();
  const registrationStatus = getRegistrationStatus(registration);
  const { goToCategoryPage } = useRedirectToCategory();
  const { userDetails: user, userIsLoggedIn: isLoggedIn, isUserPaid } = useUserDetails();
  const [openModal, setOpenModal] = useState(false);
  const offerDescription =
    courseDetails?.courseMetaDetails?.offerDescription || courseDetails?.offerDescription;
  const handleScrollToPlanSection = (href: string) => {
    const section = document.getElementById(href);
    const sectionTop = Number(section?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };

  const handleGAEvent = (source: string) => {
    const GAEventData = {
      source,
      ...utmQuery,
    };
    GAevent('sk_login_page_visit', GAEventData);
  };

  const { initApp } = usePWAuthWebSDK({
    sdkProps: {
      themeFor: 'skills',
      onGoogleSignIn: () => {
        // your logic
      },
      googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
      cameFrom: AuthEnums.BLOG,
      ctaName: AuthEnums.LOGIN,
      formLocation: 'course_description',
      course_batch_name: courseTitle,
      course_batch_slug: slug,
      course_batch_category: parentCategoryDetails?.title,
      course_batch_id: _id,
      course_batch_cohort_id:
        courseDetails?.batchCategoryId ||
        (courseMetaDetails as any)?.cohortId?._id ||
        (courseMetaDetails as any)?.cohortId,
      price: typeof currentPrice === 'number' ? currentPrice : undefined,
      discount_percentage: typeof discount === 'number' ? discount : undefined,
      is_free: effectivePricing?.isFree,
    },
    onAuthSuccessCallBack: () => {
      setOpenModal(true);
    },
  });

  const sendGAEvent = (clickText: string) => {
    const GAEventData = {
      user_id: user?._id,
      user_type: isLoggedIn ? 'logged_in' : 'logged_out',
      user_category: user?.userType || '',
      click_text: clickText,
      page_name: 'course_description_page',
      course_id: courseDetails?._id || '',
      course_name: courseDetails?.name || courseDetails?.title || '',
      category_id: courseDetails?.parentCategoryDetails?._id || '',
      category_name: courseDetails?.parentCategoryDetails?.title || '',
      course_type: courseDetails?.pricing?.isFree ? 'free' : 'paid',
      utm_source: utmQuery?.utm_source || '',
      utm_medium: utmQuery?.utm_medium || '',
      utm_campaign: utmQuery?.utm_campaign || '',
      page_ref: router?.query?.from || '',
    };
    GAevent('sk_course_descrip_action', GAEventData);
  };

  const handleDownloadClick = () => {
    const resolvedCohortId =
      (courseDetails as any)?.batchCategoryId ||
      (courseMetaDetails as any)?.cohortId?._id ||
      (courseMetaDetails as any)?.cohortId ||
      (courseDetails as any)?.cohortId?._id ||
      '';
    const fallbackPriceRaw = effectivePricing?.IN ?? effectivePricing?.US;
    const resolvedPrice =
      typeof currentPrice === 'number' && !Number.isNaN(currentPrice)
        ? currentPrice
        : typeof fallbackPriceRaw === 'number' && !Number.isNaN(fallbackPriceRaw)
        ? fallbackPriceRaw
        : undefined;
    const fallbackDiscountRaw = effectivePricing?.discount;
    const resolvedDiscount =
      typeof discount === 'number' && !Number.isNaN(discount)
        ? discount
        : typeof fallbackDiscountRaw === 'number' && !Number.isNaN(fallbackDiscountRaw)
        ? fallbackDiscountRaw
        : undefined;

    sendSkCtaClickedEvent({
      userData: user,
      isLoggedIn,
      isUserPaid,
      page_path: router?.pathname,
      click_text: 'Download Curriculum',
      click_id: 'download_curriculum',
      click_position: 'hero_section',
      widget_name: 'hero_section',
      page_referrer_cta: (router?.query?.clickText as string) || '',
      page_referrer_widget_name: (router?.query?.section as string) || '',
      course_name: courseDetails?.title || courseDetails?.title || '',
      course_slug: courseDetails?.slug || '',
      course_category:
        courseDetails?.parentCategoryDetails?.title ||
        (courseDetails as any)?.categoryDetails?.title ||
        (courseDetails as any)?.categoryDetails?.name ||
        (courseDetails as any)?.categoryDetails?.slug ||
        '',
      course_id: courseDetails?._id || '',
      cohort_id: resolvedCohortId,
      price: resolvedPrice,
      discount_percentage: resolvedDiscount,
      is_free: !!effectivePricing?.isFree,
    });

    sendGAEvent('download curriculum');
    if (isLoggedIn) {
      setOpenModal(true);
    } else {
      initApp();
      handleGAEvent('Download Curriculum');
    }
  };

  const getImageUrl = () => {
    if (courseDetails?.previewImageUrl) {
      return courseDetails.previewImageUrl.startsWith('https')
        ? courseDetails.previewImageUrl
        : createImageUrl(courseDetails.previewImageUrl);
    }
    if (effectiveImg) {
      return effectiveImg.startsWith('https')
        ? effectiveImg
        : `${companyImage}/thumbnails/${effectiveImg}`;
    }

    return '';
  };

  useEffect(() => {
    if (router.isReady && goToPlanSection === 'true') {
      setTimeout(() => {
        handleScrollToPlanSection('plans');
      }, 500);
    }
  }, [router.isReady, goToPlanSection]);
  const getBreadcrumbs = () => {
    const isFromPage = router?.query?.from || navigationContext.from;
    const breadcrumbCategoryName =
      (router?.query?.category_name as string) || navigationContext.categoryName;
    const breadcrumbCategorySlug =
      (router?.query?.category_slug as string) || navigationContext.categorySlug;
    if (isFromPage === PAGE_FROM_ROUTES.COURSE_LISTING_PAGE) {
      // If the user comes from the /courses route
      return (
        <div className="flex items-center gap-1 mb-8 medium:!mb-0">
          <div className="flex gap-1 justify-center items-center text-gray-650  ">
            <Home className={`w-3 h-3 ${!isArmature ? 'text-white' : 'text-gray-800'}`} />
            <Typography
              component="body-small"
              variant="regular"
              className={`${
                !isArmature ? 'text-white' : 'text-gray-800'
              } cursor-pointer whitespace-nowrap`}
              onClick={() => {
                router.push('/');
              }}
            >
              Home {`>`}
            </Typography>
          </div>
          <Typography
            component="body-small"
            variant="bold"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } cursor-pointer whitespace-nowrap`}
            onClick={() => {
              router.push('/courses');
            }}
          >
            Courses {`>`}
          </Typography>
          <Typography
            component="body-small"
            variant="bold"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } whitespace-nowrap overflow-hidden text-ellipsis`}
          >
            {courseTitle}
          </Typography>
        </div>
      );
    }

    if (isFromPage === PAGE_FROM_ROUTES.CATEGORY_PAGE) {
      // If the user comes from the /courses route
      return (
        <div className="flex items-center gap-1 mb-8 medium:!mb-0">
          <div className="flex gap-1 justify-center items-center text-gray-650  ">
            <Home className={`w-3 h-3 ${!isArmature ? 'text-white' : 'text-gray-800'}`} />
            <Typography
              component="body-small"
              variant="regular"
              className={`${
                !isArmature ? 'text-white' : 'text-gray-800'
              } cursor-pointer whitespace-nowrap`}
              onClick={() => {
                router.push('/');
              }}
            >
              Home
            </Typography>
          </div>
          {breadcrumbCategoryName && (
            <Typography
              component="body-small"
              variant="regular"
              className={`${
                !isArmature ? 'text-white' : 'text-gray-800'
              } cursor-pointer whitespace-nowrap  overflow-hidden text-ellipsis max-w-[30%] medium:w-auto`}
              onClick={() => {
                goToCategoryPage(breadcrumbCategorySlug as string, '');
              }}
            >
              {`>`} {breadcrumbCategoryName}
            </Typography>
          )}

          <Typography
            component="body-small"
            variant="bold"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } whitespace-nowrap  overflow-hidden text-ellipsis`}
          >
            {`>`} {courseTitle}
          </Typography>
        </div>
      );
    }

    if (isFromPage === PAGE_FROM_ROUTES.LEARN_PAGE) {
      return (
        <div className="flex items-center gap-1 mb-8 medium:!mb-0">
          <div className="flex gap-1 justify-center items-center text-gray-650  ">
            <Home className={`w-3 h-3 ${!isArmature ? 'text-white' : 'text-gray-800'}`} />
            <Typography
              component="body-small"
              variant="regular"
              className={`${
                !isArmature ? 'text-white' : 'text-gray-800'
              } cursor-pointer whitespace-nowrap`}
              onClick={() => {
                router.push('/');
              }}
            >
              Home {`>`}
            </Typography>
          </div>
          <Typography
            component="body-small"
            variant="bold"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } cursor-pointer whitespace-nowrap`}
            onClick={() => {
              router.push('/dasboard/mycourse');
            }}
          >
            Learn {`>`}
          </Typography>
          <Typography
            component="body-small"
            variant="bold"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } whitespace-nowrap  overflow-hidden text-ellipsis`}
          >
            {courseTitle}
          </Typography>
        </div>
      );
    }

    if (isFromPage === PAGE_FROM_ROUTES.MASTERCLASS_DESCRIPTION_PAGE) {
      // If the user comes from the /courses route
      return (
        <div className="flex items-center gap-1 mb-8 medium:!mb-0">
          <div className="flex gap-1 justify-center items-center text-gray-650  ">
            <Home className={`w-3 h-3 ${!isArmature ? 'text-white' : 'text-gray-800'}`} />
            <Typography
              component="body-small"
              variant="regular"
              className={`${
                !isArmature ? 'text-white' : 'text-gray-800'
              } cursor-pointer whitespace-nowrap`}
              onClick={() => {
                router.push('/');
              }}
            >
              Home {`>`}
            </Typography>
            <Typography
              component="body-small"
              variant="regular"
              className={`${
                !isArmature ? 'text-white' : 'text-gray-800'
              } cursor-pointer whitespace-nowrap`}
              onClick={() => {
                router.push('/masterclass');
              }}
            >
              Masterclass {`>`}
            </Typography>
          </div>
          <Typography
            component="body-small"
            variant="regular"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } cursor-pointer whitespace-nowrap  overflow-hidden text-ellipsis max-w-[30%] medium:w-auto`}
            onClick={() => {
              router.push(`/masterclass/${masterclassSlug}`);
            }}
          >
            {router?.query?.masterClassTitle}
          </Typography>

          <Typography
            component="body-small"
            variant="bold"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            }  whitespace-nowrap  overflow-hidden text-ellipsis`}
          >
            {`>`} {courseTitle}
          </Typography>
        </div>
      );
    }
    // Default: Home > Category Name > Course Name
    return (
      <div className="flex items-center gap-1 mb-8 medium:!mb-0">
        <div className="flex gap-1 justify-center items-center text-gray-650">
          <Home className={`w-3 h-3 ${!isArmature ? 'text-white' : 'text-gray-800'}`} />
          <Typography
            component="body-small"
            variant="regular"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } cursor-pointer whitespace-nowrap`}
            onClick={() => {
              router.push('/');
            }}
          >
            Home
          </Typography>
        </div>
        {categoryName && categorySlugValue && (
          <Typography
            component="body-small"
            variant="regular"
            className={`${
              !isArmature ? 'text-white' : 'text-gray-800'
            } cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis max-w-[30%] medium:w-auto`}
            onClick={() => {
              goToCategoryPage(categorySlugValue, '');
            }}
          >
            {`>`} {categoryName}
          </Typography>
        )}
        <Typography
          component="body-small"
          variant="bold"
          className={`${
            !isArmature ? 'text-white' : 'text-gray-800'
          } whitespace-nowrap overflow-hidden text-ellipsis`}
        >
          {`>`} {courseTitle}
        </Typography>
      </div>
    );
  };

  const sendDataLayerEvent = (videoUrl: string, section: string) => {
    const dataLayerObj = {
      event: 'video_click',
      section_name: section,
      course_id: _id,
      video_url: videoUrl,
    };
    dataLayer(dataLayerObj);
  };

  return (
    <div className="relative z-50 pt-12 pb-0 medium:pt-18 medium:pb-0">
      <VideoModal
        title="No cost emi"
        modalOpen={emiModal}
        setModelOpen={setEmiModal}
        videoUrl={emi?.videoLink || ''}
        description={emi?.description || ''}
        type="emi"
      />
      <Container className={`relative z-[1] ${!isArmature ? 'px-4 large:px-20' : '!px-0'}`}>
        <SocialShareModal
          modelOpen={open}
          setModelOpen={setOpen}
          url={slug ? `${DOMAIN}/${parentCategoryDetails?.slug}/${slug}` : ''}
          title={courseTitle || ''}
        />
        <div className="flex flex-col medium:gap-[26px] large:gap-[38px]">
          {getBreadcrumbs()}
          <div
            className={classNames(
              'flex w-full medium:!gap-[17px] large:!gap-[24px] flex-col-reverse medium:flex-row items-start',
              !ratingAverage || ratingAverage < 3 ? 'gap-y-4' : ''
            )}
          >
            <div className="w-full medium:w-1/2 medium:max-w-[628px] flex flex-col gap-2">
              <div className="flex flex-col gap-2">
                {((hashtagDetails && hashtagDetails.length > 0 && hashtagDetails[0].value !== '') ||
                  courseMetaDetails?.hashTag ||
                  '') && (
                  <div className="bg-[#FFF0ED] py-[2px] px-2 rounded h-fit !w-auto self-start">
                    <Typography
                      component="body-tiny"
                      variant="bold"
                      className="text-[#D2614B] text-center capitalize !text-[12px]"
                    >
                      #{(hashtagDetails && hashtagDetails[0]?.value) || courseMetaDetails?.hashTag}
                    </Typography>
                  </div>
                )}
                <div>
                  <Typography
                    component="h2"
                    variant="bold"
                    className={`${
                      !isArmature ? 'text-white ' : 'text-gray-900'
                    } text-2xl medium:!text-4xl !line-clamp-2`}
                  >
                    {courseTitle && courseTitle?.length > 70
                      ? `${courseTitle.slice(0, 67)}...`
                      : courseTitle}
                  </Typography>
                </div>

                <Typography
                  component="body-regular"
                  variant="regular"
                  className={`${!isArmature ? 'text-gray-10' : 'text-gray-800'} line-clamp-4`}
                >
                  {effectiveDescription && effectiveDescription.length > 160
                    ? `${effectiveDescription.slice(0, 157)}...`
                    : effectiveDescription}
                </Typography>
              </div>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setOpen(true);
                }}
                className="px-2 py-2 rounded-[56px] bg-gray-50 flex justify-center items-center w-fit"
              >
                <ArrowRedo className="text-orange-500 w-4 h-4 cursor-pointer" />
              </button>

              <div className="hidden large:!flex large:!flex-col gap-1 mt-7">
                {!priceDetails?.isCourseFree ? (
                  <div className="flex gap-x-6 gap-y-2 items-center flex-col small:!flex-row flex-wrap">
                    <div className="flex gap-2 justify-center items-center">
                      {coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL && (
                        <>
                          <div className="flex gap-[2px] justify-center items-center">
                            <Typography
                              variant="semi-bold"
                              component="h3"
                              className={`${!isArmature ? 'text-white ' : 'text-gray-850'}`}
                            >
                              {currency}
                            </Typography>
                            <Typography
                              variant="semi-bold"
                              component="h3"
                              className={`${!isArmature ? 'text-white ' : 'text-gray-850'}`}
                            >
                              {Math.floor(currentPrice as number)}
                            </Typography>
                          </div>
                          {effectivePricing && effectivePricing?.discount > 0 && (
                            <Typography
                              variant="strikethrough"
                              component="h4"
                              className={`${!isArmature ? 'text-gray-10  ' : 'text-gray-650'}`}
                            >
                              {Math.floor(actualPrice as number)}
                            </Typography>
                          )}
                        </>
                      )}
                      {coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN && (
                        <Typography
                          component="subheading"
                          variant="semi-bold"
                          className={`${!isArmature ? 'text-white' : 'text-gray-800'}`}
                        >
                          {effectivePricing?.emiText}
                        </Typography>
                      )}
                    </div>
                    {effectivePricing &&
                      effectivePricing?.discount > 0 &&
                      coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL && (
                        <div className="flex gap-2 justify-center items-center">
                          <Discount className="w-6 h-6 text-green-200" />
                          <Typography
                            variant="semi-bold"
                            component="h4"
                            className="text-green-200 font-inter"
                          >
                            {Math.floor(discount as number)}% Discount
                          </Typography>
                        </div>
                      )}
                  </div>
                ) : (
                  <Typography variant="semi-bold" component="h4" className="font-inter">
                    FREE
                  </Typography>
                )}

                {coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL && offerDescription && (
                  <div className="flex">
                    <Typography
                      component="body-regular"
                      variant="semi-bold"
                      className="text-red-300 capitalize !text-[16px]"
                    >
                      {offerDescription}
                    </Typography>
                  </div>
                )}
              </div>
              <div className="hidden large:!flex gap-4">
                <Tooltip
                  text={registrationStatus || ''}
                  className={`${
                    !registration?.startDate ||
                    registration?.startDate === '' ||
                    registrationStatus === REGISTRATION_STATUS.OPEN ||
                    isCourseBought ||
                    coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN
                      ? 'hidden'
                      : ''
                  }`}
                >
                  <CardFooterButton2
                    classes="rounded-lg w-full medium:!w-[200px] bg-orange-500"
                    title={courseTitle}
                    slug={slug}
                    pageFrom="course_description_page"
                    courseId={_id || ''}
                    isFree={effectivePricing && effectivePricing?.isFree}
                    ctaOnCard={(effectivePricing && effectivePricing?.ctaOnCard) || ''}
                    coursePurchaseType={coursePurchaseType || ''}
                    courseType={courseType || ''}
                    isDescriptionPage
                    disabled={
                      registration?.startDate !== '' &&
                      registrationStatus !== REGISTRATION_STATUS.OPEN &&
                      !isCourseBought
                    }
                    sectionFrom="hero_section"
                    courseprice={priceDetails?.currentPrice || priceDetails?.actualPrice}
                    discountPercentage={
                      (effectivePricing?.discount as number | undefined) ?? priceDetails?.discount
                    }
                    planCourses={courseDetails?.courseMetaDetails?.coursePlansDetails || []}
                    categoryId={
                      courseDetails?.batchCategoryId || courseDetails?.parentCategoryDetails?._id
                    }
                    categoryName={parentCategoryDetails?.title}
                  />
                </Tooltip>
                {curriculumPdf && (
                  <div
                    className={`flex items-center px-3 py-2 border border-[#E97862] rounded-lg hover:cursor-pointer gap-2 transition-all duration-300 ease-in-out ${
                      isHovered ? 'w-[220px]' : 'w-[50px]'
                    }`}
                    onMouseEnter={() => {
                      setIsHovered(true);
                    }}
                    onMouseLeave={() => {
                      setIsHovered(false);
                    }}
                    onClick={handleDownloadClick}
                    style={{ minWidth: '50px' }}
                  >
                    <img
                      src="/images/homePageRevamp/download.svg"
                      alt="download certificate"
                      className="w-6 h-6 rounded-[8px] medium:!rounded-[20px] transition-transform duration-300 ease-in-out"
                    />
                    <div
                      className={`overflow-hidden transition-all duration-300 ease-in-out ${
                        isHovered ? 'opacity-100' : 'opacity-0'
                      }`}
                    >
                      <Typography
                        variant="semi-bold"
                        component="body-regular"
                        className="text-[#E97862] whitespace-nowrap"
                      >
                        Download Curriculum
                      </Typography>
                    </div>
                  </div>
                )}
              </div>

              {emi?.isNoCostEmi && (
                <button
                  type="button"
                  className="hidden large:!inline-flex"
                  onClick={() => setEmiModal(true)}
                >
                  <Typography
                    variant="regular"
                    component="body-regular"
                    className="text-yellow-300 inline-flex gap-x-2 underline underline-offset-8 pt-3 regular:!pt-8"
                  >
                    <InformationCircle className="w-6 h-6" />
                    No Cost EMI Options Available*
                  </Typography>
                </button>
              )}

              {isArmature &&
                getCountryFromCache() === 'IN' &&
                !priceDetails?.isCourseFree &&
                priceDetails &&
                priceDetails?.currentPrice >= 1500 && (
                  <Typography
                    variant="regular"
                    component="body-regular"
                    className="text-stroke-400 hidden large:!flex mt-5"
                  >
                    <sup>*</sup>EMI Options Available
                  </Typography>
                )}
            </div>
            <VideoModal
              title={courseTitle || ''}
              modalOpen={modelOpen}
              setModelOpen={setModelOpen}
              videoUrl={videoURL || ''}
              section="overview"
            />
            <div className="flex flex-col w-full medium:w-1/2 medium:max-w-[628px] gap-4">
              <div className="medium:!pl-6 large:!pr-6">
                {(courseDetails?.previewImageUrl || effectiveImg || videoURL) && (
                  <div
                    className="relative !shrink-0 shadow-light h-fit medium:!rounded-[20px] rounded-[8px]"
                    onClick={() => {
                      if (videoURL) {
                        setModelOpen(true);
                        sendDataLayerEvent(videoURL, 'overview');
                      }
                    }}
                    aria-hidden="true"
                  >
                    <img
                      // upload thumbnail logic is updated - newer uploads will return s3 bucket url and older one will return id
                      src={getImageUrl()}
                      alt={thumbnailImgAltText || ''}
                      loading="lazy"
                      // width={519}
                      // height={298}
                      className="!w-full !h-[189px] large:!h-[322px] !shrink-0 medium:!rounded-[20px] rounded-[8px]"
                    />
                    {videoURL && (
                      <>
                        <div className="absolute w-[100%] h-[100%] medium:!rounded-[20px] rounded-[8px] translate-y-[-50%] top-[50%] left-[50%] translate-x-[-50%] bg-black opacity-[0.3] cursor-pointer" />
                        <div className="translate-x-[-50%] w-[42px] h-[42px] flex justify-center items-center rounded-[50%] bg-white translate-y-[-50%] absolute top-[50%] left-[50%] cursor-pointer">
                          <PlayIcon className="pl-1 !text-orange-500" />
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
              {isJobAssistanceProgram && (
                <div className="self-start regular:!self-end pb-3 pt-1">
                  <Link href="/career-services">
                    <Typography
                      component="body-regular"
                      variant="regular"
                      className={` underline underline-offset-4"  ${
                        !isArmature ? 'text-white' : 'text-gray-800'
                      }`}
                    >
                      Click here to know more about job policies*
                    </Typography>
                  </Link>
                </div>
              )}
              {/* <div className="hidden large:!block">
                <HeroMetaData keyValueMetaInfo={keyValueMetaInfo} isArmature={isArmature} />
              </div> */}
            </div>
          </div>

          {/* <div className="block large:!hidden mt-4 mb-4 medium:mt-0 medium:mb-0">
            <HeroMetaData keyValueMetaInfo={keyValueMetaInfo} isArmature={isArmature} />
          </div> */}

          {/* for tablets pricing and buttons */}
          <div className="flex flex-col medium:!flex medium:!flex-row large:!hidden gap-4 medium:justify-between medium:items-center">
            <div className="flex flex-col gap-1">
              {!priceDetails?.isCourseFree ? (
                <div className="flex gap-x-6 gap-y-2 items-center flex-col small:!flex-row flex-wrap">
                  <div className="flex gap-2 justify-center items-center">
                    {coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL && (
                      <>
                        <div className="flex gap-[2px] justify-center items-center">
                          <Typography
                            variant="semi-bold"
                            component="h3"
                            className={`${!isArmature ? 'text-white ' : 'text-gray-850'}`}
                          >
                            {currency}
                          </Typography>
                          <Typography
                            variant="semi-bold"
                            component="h3"
                            className={`${!isArmature ? 'text-white ' : 'text-gray-850'}`}
                          >
                            {Math.floor(currentPrice as number)}
                          </Typography>
                        </div>
                        {effectivePricing && effectivePricing?.discount > 0 && (
                          <Typography
                            variant="strikethrough"
                            component="h4"
                            className={`${!isArmature ? 'text-gray-10  ' : 'text-gray-650'}`}
                          >
                            {Math.ceil(actualPrice as number)}
                          </Typography>
                        )}
                      </>
                    )}
                    {coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN && (
                      <Typography
                        component="subheading"
                        variant="semi-bold"
                        className={`${!isArmature ? 'text-white' : 'text-gray-800'}`}
                      >
                        {effectivePricing?.emiText}
                      </Typography>
                    )}
                  </div>
                  {effectivePricing &&
                    effectivePricing?.discount > 0 &&
                    coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL && (
                      <div className="flex gap-2 justify-center items-center">
                        <Discount className="w-6 h-6 text-green-200" />
                        <Typography
                          variant="semi-bold"
                          component="h4"
                          className="text-green-200 font-inter"
                        >
                          {Math.floor(discount as number)}% Discount
                        </Typography>
                      </div>
                    )}
                </div>
              ) : (
                <Typography variant="semi-bold" component="h4" className="font-inter">
                  FREE
                </Typography>
              )}

              {coursePurchaseType === COURSE_PURCHASE_TYPE.INDIVIDUAL && offerDescription && (
                <div className="flex">
                  <Typography
                    component="body-regular"
                    variant="semi-bold"
                    className="text-red-300 capitalize !text-[16px]"
                  >
                    {offerDescription}
                  </Typography>
                </div>
              )}
            </div>

            {/* buttons */}
            <div className="flex gap-4 flex-col medium:!flex-row ">
              {curriculumPdf && (
                <div>
                  <div
                    className="flex medium:!hidden items-center px-3 py-2 border border-orange-500 rounded-lg hover:cursor-pointer gap-2 transition-all duration-300 ease-in-out w-full justify-center"
                    style={{ minWidth: '50px' }}
                    onClick={handleDownloadClick}
                  >
                    <img
                      src="/images/homePageRevamp/download.svg"
                      alt="download certificate"
                      className="w-6 h-6 rounded-[8px] medium:!rounded-[20px] transition-transform duration-300 ease-in-out"
                    />
                    <Typography
                      variant="semi-bold"
                      component="body-regular"
                      className="text-[#E97862] whitespace-nowrap"
                    >
                      Download Curriculum
                    </Typography>
                  </div>
                  <div
                    className={`hidden medium:!flex items-center px-3 py-2 border border-orange-500 rounded-lg hover:cursor-pointer gap-2 transition-all duration-300 ease-in-out ${
                      isHovered ? 'w-[220px]' : 'w-[50px]'
                    }`}
                    onMouseEnter={() => {
                      setIsHovered(true);
                    }}
                    onMouseLeave={() => {
                      setIsHovered(false);
                    }}
                    onClick={handleDownloadClick}
                    style={{ minWidth: '50px' }}
                  >
                    <img
                      src="/images/homePageRevamp/download.svg"
                      alt="download certificate"
                      className="w-6 h-6 rounded-lg medium:!rounded-[20px] transition-transform duration-300 ease-in-out"
                    />
                    <div
                      className={`overflow-hidden transition-all duration-300 ease-in-out ${
                        isHovered ? 'opacity-100' : 'opacity-0'
                      }`}
                    >
                      <Typography
                        variant="semi-bold"
                        component="body-regular"
                        className="text-orange-500 whitespace-nowrap"
                      >
                        Download Curriculum
                      </Typography>
                    </div>
                  </div>
                </div>
              )}

              <Tooltip
                text={registrationStatus || ''}
                className={`${
                  !registration?.startDate ||
                  registration?.startDate === '' ||
                  registrationStatus === REGISTRATION_STATUS.OPEN ||
                  isCourseBought ||
                  coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN
                    ? 'hidden'
                    : ''
                }`}
              >
                <CardFooterButton2
                  classes="rounded-lg w-full medium:!w-[200px] bg-orange-500"
                  title={courseTitle}
                  slug={slug}
                  pageFrom="course_description_page"
                  courseId={_id || ''}
                  isFree={effectivePricing && effectivePricing.isFree}
                  ctaOnCard={(effectivePricing && effectivePricing.ctaOnCard) || ''}
                  coursePurchaseType={coursePurchaseType || ''}
                  courseType={courseType || ''}
                  isDescriptionPage
                  disabled={
                    registration?.startDate !== '' &&
                    registrationStatus !== REGISTRATION_STATUS.OPEN &&
                    !isCourseBought
                  }
                  sectionFrom="hero_section"
                  planCourses={courseDetails?.courseMetaDetails?.coursePlansDetails || []}
                  categoryId={courseDetails?.batchCategoryId}
                  categoryName={parentCategoryDetails?.title}
                  courseprice={priceDetails?.currentPrice || priceDetails?.actualPrice}
                  discountPercentage={
                    (effectivePricing?.discount as number | undefined) ?? priceDetails?.discount
                  }
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </Container>
      {openModal && (
        <OnboardingLeadForm
          type={LeadType.DOWNLOAD_CURRICULUM}
          modalType={ModalType.LEAD_FORM}
          modalOpen={openModal}
          setModalOpen={setOpenModal}
          curriculumPdf={curriculumPdf}
          enquiryTypeNPF="Download Curriculum"
          enquiryType={LeadCaptureEnquiryType.DOWNLOAD_CURRICULUM}
          pageName="course_description"
          leadCaptureType={LeadCaptureType.MODAL}
          buttonText=""
          msgLineOne="Your file is now started downloading"
        />
      )}

      {/* <div className="wave" /> */}
      {/* wave creation for professional course */}

      {/* {!isArmature && (
        <div className="waves_container hidden large:!block z-0">
          <div className="absolute w-full h-full">
            <svg
              className="waves"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 24 150 28"
              preserveAspectRatio="none"
              shapeRendering="auto"
            >
              <defs>
                <path
                  id="gentle-wave"
                  d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                />
              </defs>
              <g className="parallax">
                <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(42,50,54,1" />
              </g>
            </svg>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default HeroContainer;
